export const sidebarCategoriesNesting = 3;

export const homepageSlideHeroTag = "hero";

export const detailsSlugUrlLimiter = ":";